import React, { useState } from "react";
import "../../style/progressbar.css";

const ProgressBar = () => {
  const [time, setTime] = useState(5);
  const [progress, setProgress] = useState(0);

  const startTimer = () => {
    let current = 0;
    const total = Number(time);

    const interval = setInterval(() => {
      current++;

      const percent = (current / total) * 100;
      setProgress(percent);

      if (current >= total) {
        clearInterval(interval);
      }
    }, 1000);
  };

  return (
    <div className="col-md-8 col-lg-8 col-xl-8">
      <h1 className="mb-3 fw-normal border-bottom pb-2 mb-4">
        Progress Bar
      </h1>

      <input
        type="number"
        value={time}
        onChange={(e) => setTime(e.target.value)}
        className="time-input"
      />

      <button
        className="btn btn-primary ms-2"
        onClick={startTimer}
      >
        Start
      </button>

      <div className="progress mt-4">
        <div
          className="progress-bar progress-bar-striped progress-bar-animated bg-success"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar;